module.exports = __webpack_public_path__ + "static/media/sqlite.94c7c3f7.png";